import React from 'react';

interface UserStatItemProps {
  label: string;
  value: number;
  color: 'primary' | 'success' | 'accent';
  showBorder?: boolean;
}

const colorClasses = {
  primary: 'text-primary-600 dark:text-primary-300',
  success: 'text-success-600 dark:text-success-400',
  accent: 'text-secondary-dark dark:text-secondary-main',
};

/**
 * Reusable component for displaying user engagement statistics
 */
export const UserStatItem: React.FC<UserStatItemProps> = ({
  label,
  value,
  color,
  showBorder = true,
}) => {
  return (
    <div
      className={`flex items-center justify-between ${showBorder ? 'border-b border-gray-200 pb-4' : ''}`}
    >
      <span className="text-gray-600">{label}</span>
      <span className={`text-2xl font-bold ${colorClasses[color]}`}>
        {value.toLocaleString()}
      </span>
    </div>
  );
};
